var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"machine-outstanding row ma-0 mt-5"},[_c('span',[_vm._v(_vm._s(_vm.$t('title.outstanding'))+" :")]),_c('v-spacer'),_c('span',[_vm._v(_vm._s(_vm.getMachineStatement.turn_over))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }